import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// ...
import translationDE from './languages/de/translation.json';
import translationUS from './languages/en_US/translation.json';
import translationES from './languages/es/translation.json';
import translationFR from './languages/fr/translation.json';
import translationJAP from './languages/jap/translation.json';
import translationRU from './languages/ru/translation.json';
import translationZH from './languages/zh/translation.json';

// the translations
const resources = {
  de: {
    translation: translationDE,
  },
  en: {
    translation: translationUS,
  },
  es: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
  jap: {
    translation: translationJAP,
  },
  ru: {
    translation: translationRU,
  },
  zh: {
    translation: translationZH,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',

    fallbackLng: 'en', // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
